

















import { Component, Vue } from 'vue-property-decorator'

import VueElementLoading from 'vue-element-loading'
import { LoopingRhombusesSpinner } from 'epic-spinners'

import { sharedInstance as loading } from '@/signals/LoadingSignal'

import assign from 'lodash/assign'

const defaultLoadingMessage = 'Loading'

@Component({
	components: {
		VueElementLoading,
		LoopingRhombusesSpinner
	}
})
export default class LoadingComponent extends Vue
{
	private loadingOptions: LoadingOptions = {
		active: false,
		message: defaultLoadingMessage,
		size: 100,
		color: '#FFAD00',
		backgroundColor: '#421278ec'
	}

	created()
	{
		loading.asObservable().subscribe((data: LoadingOptions) => {
			if (data.active && !data.message)
			{
				data.message = defaultLoadingMessage
			}
			assign(this.loadingOptions, data)
		})
	}
}

